export default __webpack_public_path__ + "static/media/p4.77745b60.jpg";